import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["autocomplete", "type", "disabled", "maxlength", "placeholder", "value"]
const _hoisted_5 = ["autocomplete", "type", "disabled", "maxlength", "placeholder", "value"]
const _hoisted_6 = {
  key: 2,
  class: "pointer-events-none absolute top-[30%] right-0 mr-3 h-6 w-6 animate-spin text-grey",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.prefix)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.prefix), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.mask)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          autocomplete: _ctx.autocomplete,
          type: _ctx.type,
          disabled: _ctx.loading || _ctx.disabled,
          class: _normalizeClass([[
        { 'pl-8': _ctx.prefix, border: _ctx.border },
        _ctx.background,
        `rounded-${_ctx.rounded}`,
        _ctx.height,
      ], "block flex w-full py-3 px-4 text-sm text-grey focus:border-yellow-200"]),
          maxlength: _ctx.maxlength,
          placeholder: _ctx.placeholder,
          value: _ctx.model,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, null, 42, _hoisted_4)), [
          [_directive_mask, _ctx.mask]
        ])
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          autocomplete: _ctx.autocomplete,
          type: _ctx.type,
          disabled: _ctx.loading || _ctx.disabled,
          class: _normalizeClass([[
        { 'pl-8': _ctx.prefix, border: _ctx.border },
        _ctx.background,
        `rounded-${_ctx.rounded}`,
        _ctx.height,
      ], "block flex w-full py-3 pl-4 pr-6 text-sm text-grey focus:border-yellow-200"]),
          maxlength: _ctx.maxlength,
          placeholder: _ctx.placeholder,
          value: _ctx.model,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, null, 42, _hoisted_5)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("path", {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "#fcfcfc"
          }, null, -1),
          _createElementVNode("path", {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "#5E79FF"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}